import React from 'react';

const BranchColumnItemOption = ({ branchOptionLabel, isActive, columnNo, handleOptionSelect, branchId, branchOptionId }) => {
    return (
        <div onClick={() => handleOptionSelect(columnNo, branchId, branchOptionId)} className={`branch__column__option ${isActive ? 'branch__options__active' : ''}`}>{branchOptionLabel}</div>
    )
}

export default BranchColumnItemOption;